import { RefObject, useEffect, useRef } from 'react';

const useOutsideClick = <T>(
	callback: (event: MouseEvent) => void,
	type: any = 'mousedown',
	ignoreNode?: RefObject<T>,
) => {
	const ref = useRef<T>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			const isFinded =
				ref.current &&
				(ref.current as any).contains(event.target as Node);
			const isFindExtend = ignoreNode?.current
				? (ignoreNode.current as any).contains(event.target as Node)
				: false;
			if (!isFinded && !isFindExtend) {
				callback(event);
			}
		};
		document.addEventListener(type, handleClickOutside);
		return () => {
			document.removeEventListener(type, handleClickOutside);
		};
		// eslint-disable-next-line
	}, [callback]);

	return ref as RefObject<T>;
};

export default useOutsideClick;
